import moment from "moment"
import TitleModal from "./common/titleModal"
import { useTranslation } from "react-i18next"
import { Trans } from 'react-i18next';

const MeetingBox = ({ title, meeting }: { title?: string, meeting: any }) => {
  const { t } = useTranslation()

  return (
    <>
      {title && <TitleModal title={t("telemedicine-join.meeting-title")} />}
      <p>
        <Trans
          i18nKey="telemedicine-join.meeting-desc"
          values={{
            serviceName: meeting.serviceName,
            doctorFullName: meeting.doctorFullName,
            weekDay: moment(meeting.startDate).format('dddd'),
            startDay: moment(meeting.startDate).format('LL'),
            startTime: moment(meeting.startDate).format('LT'),
            endTime: moment(meeting.endDate).format('LT'),
          }}
          components={{ b: <strong /> }}
        />
      </p>
      <p>
        <Trans
          i18nKey="telemedicine-join.meeting-desc2"
          values={{
            eventName: meeting.eventName,
          }}
          components={{ b: <strong /> }} />
      </p>
    </>
  )
}

export default MeetingBox
